import SearchResult from './SearchResult'

const eventTrackerInfo = (hit, type, idx) => {
  let track = {
    type: 'Topic Clicked',
    topic_url: hit.topic_url,
    click_source: 'live-search',
    topic_position: idx,
    topic_title: hit.title,
    topic_topic_type: hit.content_type ? hit.content_type : type
  }
  if (type !== 'zendesk') {
    track.category_id = hit.forum
    track.category_title = hit.forum_title
  }

  let gaEvents = {
    eventCategory: 'Live Search',
    eventAction: 'Topic Clicked',
    eventLabel: {
      Link: hit.topic_url,
      Position: idx,
      Type: hit.content_type ? hit.content_type : type
    }
  }

  return {
    track,
    gaEvents
  }
}

const SearchResultsSection = ({ title, searchResults, hits, highlightedIndex, getItemProps, previousResultsCount, type }) => {
  if (!hits.length) return ''
  return (
    <div>
      {
        title ? (
          <span className='algolia-search-results-section__title'>{title}</span>
        ) : ''
      }
      <ul className='algolia-search-results'>
        {
          hits.map((hit, index) => {
            return Object.assign({}, hit, {
              position: searchResults.hitsPerPage * searchResults.page + index + 1,
              queryID: searchResults.queryID
            })
          }).map((hit, defaultIndex) => {
            const index = defaultIndex + previousResultsCount
            hit.topic_url = hit.topic_url || hit.url

            const eventTrackers = eventTrackerInfo(hit, type, defaultIndex + 1)

            return <SearchResult
              key={hit.objectID}
              isHighlited={highlightedIndex === index}
              hit={hit}
              track={eventTrackers.track}
              type={type}
              gaEvents={eventTrackers.gaEvents}
              {...getItemProps({ item: hit, index })} />
          })
        }
      </ul>
    </div>
  )
}

export default SearchResultsSection
